import { useTranslation } from 'react-i18next';
import Icons from '../../../../../common/widgets/Icons';
import { CheckOutWarningType } from '../../../enums';
import { CanCheckOutModel } from '../../../models/Cart';
import { resources } from '../../../resources/resources';

interface IWarningProps {
  canCheckout: CanCheckOutModel;
}

const WarningsComponent = (props: IWarningProps) => {
  const { t: translate } = useTranslation();
  const { canCheckout } = props;

  if (canCheckout.value) return null;

  if (canCheckout.warningType === CheckOutWarningType.NotEnoughBenefitBucks)
    return (
      <div className="checkout-warning red">
        <span>
          <Icons.NotificationsError />
        </span>

        <span>{translate(resources.cart.warning.notEnoughBenefitBucks)}</span>
      </div>
    );
  if (canCheckout.warningType === CheckOutWarningType.NoTemporaryDeactivated)
    return (
      <div className="checkout-warning red">
        <span>
          <Icons.NotificationsError />
        </span>

        <span>{translate(resources.cart.errors.noTemporaryDeactivated)}</span>
      </div>
    );

  if (canCheckout.warningType === CheckOutWarningType.PlatformIsClosed)
    return (
      <div className="checkout-warning blue">
        <span>
          <Icons.InfoBlue />
        </span>

        <span>{translate(resources.cart.warning.platformIsClosed)}</span>
      </div>
    );

  return null;
};

export default WarningsComponent;
